import { useEffect, useState } from "react";
import { CheckCircle2, Server, XCircle } from "lucide-react";
import { useApi } from "@/lib/api";

const FEATURES = [["publish", "Compilatore e pubblicazione dei siti"], ["visual_review", "Revisione visiva (screenshot)"],
  ["lighthouse", "Misure Lighthouse"], ["site_render", "Lettura dei siti dei clienti con JavaScript"]];
export const gb = (mb) => (mb >= 1024 ? `${(mb / 1024).toFixed(1).replace(".", ",")} GB` : `${mb} MB`);

function Feature({ ok, label, k }) {
  return (
    <li className="flex items-center gap-1.5 text-xs text-slate-700" data-testid={`server-tools-feature-${k}`}>
      {ok ? <CheckCircle2 size={13} className="text-emerald-600 shrink-0" /> : <XCircle size={13} className="text-slate-400 shrink-0" />}
      <span>{label}: <b className={ok ? "text-emerald-700" : "text-slate-500"}>{ok ? "disponibile" : "non disponibile"}</b></span>
    </li>
  );
}

function Blocked({ t }) {
  const th = t.thresholds;
  return (
    <div className="rounded-md bg-amber-50 border border-amber-200 p-2.5 text-xs text-amber-900 space-y-1" data-testid="server-tools-reason">
      <p><b>Perché Chromium e Lighthouse non sono disponibili:</b> {t.browser.reason}.</p>
      <p>Su questo server non vengono installati né avviati, per non rischiare che lo Studio si riavvii per memoria o disco esauriti. Generazione, editor, anteprime e pubblicazione funzionano normalmente; restano disponibili i punteggi automatici di ogni compilazione.</p>
      <p>Requisiti: almeno {gb(th.browser_memory_mb)} di memoria e {gb(th.browser_disk_mb)} di disco libero per installarli.</p>
    </div>
  );
}

// Inline status of the server tools (no dedicated page): what works, and why the browser tools are off when the server is too small.
export default function ServerTools() {
  const api = useApi();
  const [t, setT] = useState(null);
  useEffect(() => { api.get("/toolchain").then(({ data }) => setT(data)).catch(() => setT(false)); }, [api]);
  if (t === null) return null;
  if (t === false) return <p className="text-xs text-slate-500" data-testid="server-tools">Stato degli strumenti del server non disponibile.</p>;
  const r = t.resources;
  return (
    <div id="server-tools" className="scroll-mt-6 rounded-lg border border-slate-200 p-3 space-y-2.5" data-testid="server-tools">
      <p className="text-xs font-semibold text-slate-900 flex items-center gap-1.5"><Server size={13} />Strumenti del server</p>
      <ul className="grid sm:grid-cols-2 gap-1.5">{FEATURES.map(([k, l]) => <Feature key={k} k={k} label={l} ok={t.features[k]} />)}</ul>
      {!t.browser.enabled && <Blocked t={t} />}
      {["installing", "waiting"].includes(t.phase) && <p className="text-xs text-sky-700" data-testid="server-tools-phase">Strumenti in preparazione (primo avvio, 1-3 minuti).</p>}
      {t.phase === "failed" && <p className="text-xs text-rose-700" data-testid="server-tools-error">Installazione non riuscita: {t.error}. Si ritenta al prossimo riavvio del backend.</p>}
      <p className="text-[11px] text-slate-500" data-testid="server-tools-resources">
        Memoria del server {gb(r.memory_mb)} · libera ora {gb(r.memory_free_mb)} · disco libero {gb(r.disk_free_mb)}. La memoria libera viene ricontrollata prima di ogni avvio di Chromium (servono {gb(t.thresholds.browser_free_mb)}).
      </p>
    </div>
  );
}
